import * as React from "react";
import { connect } from "react-redux";
import {
  getFlightMarkersState,
  getModePilotUiState,
} from "../../redux/rootReducer";
import { IGcpAppDispatch } from "../../redux/store";
import { IFlightMarkersState } from "../../redux/modules/flightMarkers/flightMarkersReducer";
import FlightMarkerItem from "./FlightMarkerItem";
import {
  IModePilotUi,
  selectActiveNail,
} from "../../redux/modules/modePilotUi/reducer";

interface IFlightMarkersListProps {
  uiState: IModePilotUi;
  nailsState: IFlightMarkersState;
  dispatch: IGcpAppDispatch;
}
const FlightMarkersList = ({
  dispatch,
  nailsState,
  uiState,
}: IFlightMarkersListProps) => (
  <>
    {nailsState.data.nails
      .filter(({ id, tsArchived }) => !tsArchived)
      .map(({ id }) => (
        <FlightMarkerItem
          key={`all-nails-nail-${id}`}
          id={id}
          isActive={id === uiState.activeNailId}
          onClick={() => dispatch(selectActiveNail(id))}
        />
      ))}
  </>
);

export default connect((state: any) => ({
  nailsState: getFlightMarkersState(state),
  uiState: getModePilotUiState(state),
}))(FlightMarkersList);
